import StyledButton from '../../../app/components/styledComponents/StyledButton';
import theme from '../../../utils/themes';
import { StyledLabel } from '../../Campaigns/CampaignDetails';
import { StyledConnectedButton } from '../../../assets/styledComponents/Global';
import SuccessIcon from '../../../app/components/svgIcons/SuccessIcon';
import Portlet from '../../../app/components/portlet/Portlet';
import PortletBody from '../../../app/components/portlet/PortletBody';
import TrashIcon from '../../../app/components/svgIcons/TrashIcon';
import { useRemoveMultiposterJobboardMutation } from '../../Products/productApiSlice';
import { toast } from 'react-toastify';
import DisconnectJobboardModal from './DisconnectJobboardModal';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import TableSkeleton from '../../../assets/skeletons/tableSkeleton';
import DeleteIcon from '../../../app/components/svgIcons/DeleteIcon';

const ConnectedJobBoards = ({data,refetch,jobLoading}) => {
    const { compId } = useParams();
  const [confrimationModal,setConfirmationModal] = useState(0);
    const [jobBoardData,setJobBoardData] = useState(null);
    const [delConnectJobBoard,{isLoading:loading}] = useRemoveMultiposterJobboardMutation();
  const handleDelete = () =>{
    let data={
      compId:compId,
      id:jobBoardData?.id
    }
    
  delConnectJobBoard(data).unwrap().then((res)=>{
  toast.success(res?.message || 'Jobboard deleted successfully');
  setJobBoardData(null);
  setConfirmationModal(false);
  refetch();
  })
  }
  return (
    <>
 <Portlet>
        <div className="portlet__body-bg">
   <PortletBody className='rounded' >
                  {!jobLoading && data?.jobBoards?.map((item,index)=>( <div className='d-flex justify-content-between align-items-center border rounded p-3 my-3'>
                                    <div className="d-flex justify-content-center align-items-center" key={index}> 
                    <StyledLabel size={'24px'} weight={600} color={theme.primary}>{item?.jobBoard?.title}</StyledLabel>
                    {/* <StyledColoredTag  backgroundColor={theme.skygreen} color={theme.green} className='mt-1'>
                                      Branded
                                    </StyledColoredTag> */}
                                    </div>
                     <div className="d-flex justify-content-center align-items-center"> 
                               <StyledConnectedButton  className="m-2 gap-2"
                                                  connectStatus={'Connected'} color={theme.successColorSky}>
                                                    <SuccessIcon/>
                                                     {'Connected'}
                                                    </StyledConnectedButton>
                            <StyledButton
                              className="me-3 py-2"
                              variant={'text'}
                              icon={<DeleteIcon size={20} color={theme?.lightBoldBlack}/>}
                              type="button"
                              onClick={()=>
                                {
                                  setConfirmationModal(true);
                                  setJobBoardData(item);
                                }
                                }
                            >
                            </StyledButton>
                          </div>
                  </div>      ))}
                  {jobLoading && 
                  <TableSkeleton    cols={[
                        ''
                      ]}
                      rows={3}/>
                  }

              </PortletBody>
     </div>
     </Portlet>
    {confrimationModal &&
        <DisconnectJobboardModal
          loading={loading}
          show={confrimationModal}
          deleteJob={handleDelete}
          onHide={() => { setConfirmationModal(false);  setJobBoardData(null);}}
          data={jobBoardData}
        />}
        </>
    
  );
};

export default ConnectedJobBoards;
